module.exports = __webpack_public_path__ + "assets/a88e59def5bcce8480c76ce58c21eef9.png";